<template>
  <div class="group">
      <label for="email">Email</label>
      <input type="text" class="validation" v-bind:class="{ '-invalid': $parent.validation.email }" v-model="$parent.fields.email" v-on:keyup="$parent.validation.email = null">
      <div class="error-message" v-for="message in $parent.validation.email">{{ message }}</div>
  </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'email',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ]
    }
</script>
